import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useQuery } from 'react-apollo';

import Button from '../../../../../../../../components/global/Button';
import PencilIcon from '../../../../../../../../components/icons/PencilIcon';
import PhotoCaptionCaptureModal, {
  PHOTO_CAPTION_CAPTURE_MODAL,
} from './PhotoCaptionCaptureModal';
import useOpenModal from '../../../../../../../../hooks/useOpenModal';
import EyeSlashIcon from '../../../../../../../../components/icons/EyeSlashIcon';
import { PhotoForCaption } from '../../../../../../../../graphql/queries/photos';
import EmojiParsed from '../../../../../../../../components/global/AutoP/EmojiParsed';

const propTypes = {
  photo: PropTypes.shape({
    id: PropTypes.string,
  }),
  isOwner: PropTypes.bool,
  className: PropTypes.string,
};

const PhotoCaption = ({ photoId, isOwner, className }) => {
  const openModal = useOpenModal();
  const { data: { photo } = {}, loading } = useQuery(PhotoForCaption, {
    variables: {
      id: photoId,
    },
    skip: !photoId,
    fetchPolicy: 'cache-first',
  });
  const { description } = photo ?? {};

  const [captionOpen, setCaptionOpen] = useState(false);

  useEffect(() => {
    if (description) {
      setCaptionOpen(true);
    }
  }, [description]);

  useEffect(() => {
    if (photo && !description && captionOpen) {
      setCaptionOpen(false);
    }
  }, [photo?.id]);

  const classes = classNames({
    'photo-grid-viewer-photo-caption': true,
    [className]: !!className,
  });

  if (loading || !photo || (!isOwner && !description)) {
    return null;
  }

  return (
    <div className={classes}>
      {isOwner && !captionOpen && (
        <Button
          onClick={() => {
            if (!description) {
              openModal(PHOTO_CAPTION_CAPTURE_MODAL);
            } else {
              setCaptionOpen(true);
            }
          }}
          btnStyle="reset"
          btnSize="sm"
          className="photo-caption-button photo-caption-button-add"
        >
          {description ? (
            <span className="text-white">Show caption</span>
          ) : (
            <>
              <PencilIcon size={12} color="#b5bcbd" /> Add a caption
            </>
          )}
        </Button>
      )}
      {!isOwner && !captionOpen && description && (
        <Button
          onClick={() => {
            setCaptionOpen(true);
          }}
          btnStyle="reset"
          btnSize="sm"
          className="photo-caption-button photo-caption-button-add"
        >
          <span className="text-white">Show caption</span>
        </Button>
      )}

      {captionOpen && (
        <div className="photo-caption-display">
          <p>
            <EmojiParsed text={description} />
          </p>
          <div className="d-flex justify-content-start">
            <Button
              btnStyle="reset"
              btnSize="sm"
              onClick={() => setCaptionOpen(false)}
            >
              <EyeSlashIcon size={12} color="#fff" />{' '}
              <span className="d-none d-md-inline">Hide caption</span>
            </Button>
            {isOwner && (
              <Button
                className="ml-2"
                btnSize="sm"
                btnStyle="reset"
                onClick={() => {
                  openModal(PHOTO_CAPTION_CAPTURE_MODAL);
                }}
              >
                <PencilIcon size={12} color="#fff" />{' '}
                <span className="d-none d-md-inline">Edit</span>
              </Button>
            )}
          </div>
        </div>
      )}

      <PhotoCaptionCaptureModal photo={photo} />
    </div>
  );
};

PhotoCaption.propTypes = propTypes;

export default PhotoCaption;
